import WebGalleryFavoriteDownloadTipModal from './WebGalleryFavoriteDownloadTipModal';

export default WebGalleryFavoriteDownloadTipModal;
